import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { AbstractJastVisitor } from '@atlassianlabs/jql-ast';

/**
 * Given an AST with parse errors, this visitor returns a valid query that is equivalent for hydration purposes
 * (i.e. just fields, operators and values). Resulting query is generated on a best-effort basis and depends on
 * a successful parser error recovery.
 *
 * Example 1:
 * - Original query: "assignee in (abc-123-def"
 * - Equivalent query: "assignee in (abc-123-def)"
 *
 * Example 2:
 * - Original query: "project = EM and status in (Done, currentUser(), EMPTY) and reporter in"
 * - Equivalent query: "project = EM and status in (Done)"
 */
export var ValidQueryVisitor = /*#__PURE__*/function (_AbstractJastVisitor) {
  _inherits(ValidQueryVisitor, _AbstractJastVisitor);
  var _super = _createSuper(ValidQueryVisitor);
  function ValidQueryVisitor() {
    var _this;
    _classCallCheck(this, ValidQueryVisitor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "visitQuery", function (query) {
      if (!query.where) {
        return '';
      }
      return query.where.accept(_assertThisInitialized(_this));
    });
    _defineProperty(_assertThisInitialized(_this), "visitCompoundClause", function (compoundClause) {
      return compoundClause.clauses.map(function (clause) {
        return clause.accept(_assertThisInitialized(_this));
      }).filter(function (value) {
        return !!value;
      }).join(' and ');
    });
    _defineProperty(_assertThisInitialized(_this), "visitTerminalClause", function (terminalClause) {
      var field = terminalClause.field,
        operator = terminalClause.operator,
        operand = terminalClause.operand;
      if (!operator || !operand) {
        return '';
      }
      var operandValue = operand.accept(_assertThisInitialized(_this));
      if (!operandValue) {
        return '';
      }
      return "".concat(field.text, " ").concat(operator.value, " ").concat(operandValue);
    });
    _defineProperty(_assertThisInitialized(_this), "visitNotClause", function (notClause) {
      return notClause.clause.accept(_assertThisInitialized(_this));
    });
    _defineProperty(_assertThisInitialized(_this), "visitValueOperand", function (valueOperand) {
      return valueOperand.text;
    });
    _defineProperty(_assertThisInitialized(_this), "visitListOperand", function (listOperand) {
      return "(".concat(listOperand.values.map(function (value) {
        return value.accept(_assertThisInitialized(_this));
      }).filter(function (value) {
        return !!value;
      }).join(', '), ")");
    });
    return _this;
  }
  _createClass(ValidQueryVisitor, [{
    key: "defaultResult",
    value: function defaultResult() {
      return '';
    }
  }]);
  return ValidQueryVisitor;
}(AbstractJastVisitor);